var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"52af534867e0558ccd23b25a7e00d8ab9e569852"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"52af534867e0558ccd23b25a7e00d8ab9e569852"};
      